import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 6m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M6 12h4m-2 -2v4","key":"svg-1"}],["path",{"d":"M15 11l0 .01","key":"svg-2"}],["path",{"d":"M18 13l0 .01","key":"svg-3"}]]

const IconDeviceGamepad = createReactComponent('outline', 'device-gamepad', 'DeviceGamepad', __iconNode);

export default IconDeviceGamepad;